<div class="calendar-container" [ngStyle]="wrapperStyles">
  <div class="w-full pl-16 pr-8 flex flex-col gap-8" [class.hidden]="!isMobile">
    <div class="pb-4 flex items-baseline justify-between gap-8">
      @if (calendarTitle.enabled) {
        <ng-container *ngTemplateOutlet="headerTitleTpl" />
      }
      <button
        type="button"
        class="btn-header self-center"
        data-cy="Calendar:ViewMode:Mobile"
        blazeClickable
        [matMenuTriggerFor]="viewToggleMenu"
        [matMenuTriggerData]="{ isMobile: true }"
      >
        <span>{{ viewModeLabel }}</span>
        <mat-icon svgIcon="icon_chevron_down_16" />
      </button>
      <div>
        @if (allCalendarsLength > 1) {
          <button
            class="btn-filter"
            [class.active]="isFilterVisible"
            blazeClickable
            (click)="toggleFilters()"
          >
            <mat-icon svgIcon="icon_filter_16" />
          </button>
        }
      </div>
    </div>
    @if (allCalendars$ | async; as calendars) {
      <div
        class="w-full pl-8"
        [ngClass]="{
          hidden: !isSwipingMode() || !isFilterVisible,
          block: isSwipingMode() && isFilterVisible,
        }"
        data-cy="Calendar:CalendarsFilter:Mobile"
      >
        <div class="filter-separator"></div>
        <ng-container
          [ngTemplateOutlet]="filtersTpl"
          [ngTemplateOutletContext]="{
            $implicit: calendars,
            filtersVisible: isFilterVisible,
          }"
        />
      </div>
    }
  </div>
  <div class="flex flex-col" [class.h-auto]="isMobile" [class.h-full]="!isMobile">
    <div
      class="pb-16 justify-between items-center gap-8 grow-0 shrink-0 basis-[56px]"
      [class.hidden]="isMobile"
      [class.flex]="!isMobile"
      [class.justify-end]="calendarTitle.align === 'right'"
    >
      @if (calendarTitle.enabled) {
        <ng-container *ngTemplateOutlet="headerTitleTpl" />
      }
    </div>
    <div class="calendar-header">
      <blaze-calendar-header
        [selectedCalendarDate]="selectedCalendarDate"
        [viewportMode]="viewportMode"
        [dateFormat]="dateFormat"
        [calendar]="calendarMonthViewComponent"
        [isCalendarVisible]="isCalendarVisible"
        (isCalendarVisibleChange)="onIsCalendarVisibleChange($event)"
        (previousDay)="selectPreviousDay()"
        (nextDay)="selectNextDay()"
        (previousPeriod)="selectPreviousPeriod()"
        (nextPeriod)="selectNextPeriod()"
      />
    </div>
    <div [class.hidden]="!isCalendarVisible" class="pt-8">
      <blaze-calendar-dates-view
        [viewportMode]="viewportMode"
        [hideWeekends]="hideWeekends"
        [firstDayOfWeek]="firstDayOfWeek"
        [datesWithEvents]="datesWithEvents"
        [selected]="selectedCalendarDate"
        (selectedChange)="onMonthViewDaySelection($event)"
      />
      <div
        class="items-center justify-center mb-16 pt-8"
        [class.hidden]="!isMobile"
        [class.flex]="isMobile"
      >
        <button
          type="button"
          class="btn-header"
          data-cy="Calendar:Today:Mobile"
          blazeClickable
          (click)="onTodayClick()"
          >Today</button
        >
      </div>
    </div>
    @if (allCalendarsLength > 1 && (allCalendars$ | async); as calendars) {
      <div
        class="flex-col overflow-hidden flex-grow"
        [class.flex]="!isMobile"
        [class.hidden]="isMobile"
        data-cy="Calendar:CalendarsFilter"
      >
        <span class="filter-label" data-cy="Calendar:CalendarsFilter:Label">
          {{ calendarsLabel }}
        </span>
        <ng-container
          [ngTemplateOutlet]="filtersTpl"
          [ngTemplateOutletContext]="{
            $implicit: calendars,
            filtersVisible: true,
          }"
        />
      </div>
    }
  </div>
  <div class="flex flex-col w-full h-full relative">
    <div
      class="w-full pb-16 justify-between gap-8 items-center h-[56px]"
      [class.flex]="!isMobile"
      [class.hidden]="isMobile"
    >
      <div
        class="bat-header-title h-full relative grow min-w-[50px] overflow-x-hidden text-left"
        data-cy="Calendar:Title"
      >
        <span
          class="absolute w-full h-full inline-flex items-center"
          [style.padding-left.px]="calendarViewMode() === CalendarView.Month ? 0 : timeLineWidthPx"
        >
          <span
            [blazeTooltip]="(selectedCalendarDate | date: dateFormat) ?? undefined"
            class="text-ellipsed blaze-leading-normal"
          >
            {{ selectedCalendarDate | date: dateFormat }}
          </span>
        </span>
      </div>
      <div class="timeline-header-buttons">
        @if (isAddEnabled()) {
          <button
            type="button"
            class="btn-header"
            data-cy="Calendar:AddAction"
            blazeClickable
            (click)="onAddClick()"
          >
            <mat-icon svgIcon="icon_add_32" />
          </button>
        }
        <button
          type="button"
          class="btn-header"
          data-cy="Calendar:ViewMode"
          blazeClickable
          [matMenuTriggerFor]="viewToggleMenu"
        >
          <span>{{ viewModeLabel }}</span>
          <mat-icon svgIcon="icon_chevron_down_16" />
        </button>
        <button
          type="button"
          class="btn-header"
          data-cy="Calendar:Today"
          blazeClickable
          (click)="onTodayClick()"
          >Today</button
        >
      </div>
    </div>

    <blaze-scroller
      [propagate]="false"
      [scrollSnapDirection]="scrollSnapDirection"
      [hideScrollX]="isSwipingMode()"
      (scroll)="updateCalendarScroll($event)"
      (mousedown)="markEventAsHandled($event)"
      class="min-h-[auto] h-full"
    >
      <div #calendarWorkspace class="calendar-workspace">
        <div class="absolute min-w-full min-h-full flex">
          @if (showLabels) {
            <div class="calendar-corner-gutter-wrapper">
              <div
                class="calendar-corner-gutter"
                [class.hidden]="calendarViewMode() === 'month'"
                [style.height.px]="headerHeightPx + 1"
                [style.width.px]="timeLineWidthPx"
              ></div>
            </div>
          }
          <div
            class="calendar-timeline"
            [class.hidden]="calendarViewMode() === 'month'"
            [style.width.px]="timeLineWidthPx"
            [style.margin-top.px]="showLabels ? headerHeightPx : 0"
          >
            @for (time of timeline; track $index) {
              <div [style.height.px]="oneHourHeight" class="timeline-hour">
                <span class="time">{{ time }}</span>
              </div>
            }
          </div>
          @if (calendarViewMode() === CalendarView.Day) {
            <div class="flex flex-grow flex-col relative w-full">
              @if (showLabels) {
                <div class="calendar-name-header min-w-full">
                  @for (calendar of calendars$ | async; track calendar.id; let i = $index) {
                    <div
                      class="calendar-name-wrapper"
                      [style.height.px]="headerHeightPx"
                      [style.width]="dayViewColumnWidth()"
                      [style.left.px]="i < 2 ? 0 : -(i - 1)"
                    >
                      <div class="flex flex-col items-center justify-center px-4 w-full">
                        <span class="calendar-name">
                          {{ calendar.name }}
                        </span>
                        @if (showTimezones) {
                          <span class="timezone">
                            {{ calendar.timeZone | formatTimeZone | async }}
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              <div
                cdkDropListGroup
                [cdkDropListGroupDisabled]="isEventDragDisabled"
                class="flex h-full w-full max-w-full"
              >
                @if (calendars$ | async; as calendars) {
                  @for (calendar of calendars; track calendar.id; let i = $index) {
                    <blaze-calendar-day-view
                      class="relative snap-end"
                      [calendar]="calendar"
                      [blazeTimeTrack]="false"
                      [events]="getEventsForSelectedDate(calendar)"
                      [selectedDate]="selectedCalendarDate"
                      [timeScale]="timeScale"
                      [availableHours]="workingHours"
                      [defaultDurationMinutes]="defaultDurationMinutes"
                      [timeFormat]="timeFormat"
                      [timeZone]="calendar.timeZone"
                      [isAddEnabled]="isAddEnabled() ?? false"
                      [isEditEnabled]="isEditEnabled() ?? false"
                      [isDeleteEnabled]="isDeleteEnabled() ?? false"
                      [isDetailsViewEnabled]="isDetailsViewEnabled() ?? false"
                      [isEventDragDisabled]="isEventDragDisabled"
                      [scrollAllDayToHour]="{ idx: i, count: calendars.length }"
                      [eventFontSize]="eventFontSize"
                      [headerHeightPx]="showLabels ? headerHeightPx : 0"
                      [style.left.px]="-i"
                      [style.width]="dayViewColumnWidth()"
                      (add)="onAddClick($event, calendar)"
                      (details)="onDetailsClick($event)"
                      (edit)="onEditClick($event)"
                      (delete)="onDeleteClick($event)"
                      (eventChange)="onEventChange($event)"
                      (eventDrop)="onEventDrop($event)"
                    />
                  }
                }
              </div>
            </div>
          }
          @if (
            calendarViewMode() === CalendarView.ThreeDay || calendarViewMode() === CalendarView.Week
          ) {
            @if (calendars$ | async; as calendars) {
              <blaze-calendar-week-view
                cdkDropListGroup
                [cdkDropListGroupDisabled]="isEventDragDisabled"
                [selectedDate]="selectedCalendarDate"
                [dates]="weekViewDateRange"
                [calendars]="calendars"
                [timeScale]="timeScale"
                [availableHours]="workingHours"
                [defaultDurationMinutes]="defaultDurationMinutes"
                [timeFormat]="timeFormat"
                [isAddEnabled]="isAddEnabled() ?? false"
                [isEditEnabled]="isEditEnabled() ?? false"
                [isDeleteEnabled]="isDeleteEnabled() ?? false"
                [isDetailsViewEnabled]="isDetailsViewEnabled() ?? false"
                [isEventDragDisabled]="isEventDragDisabled"
                [dayViewColumnWidth]="isSwipingMode() ? dayViewColumnWidth() : undefined"
                [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
                [eventFontSize]="eventFontSize"
                [headerHeightPx]="showLabels ? headerHeightPx : 0"
                (add)="onAddClick($event)"
                (details)="onDetailsClick($event)"
                (edit)="onEditClick($event)"
                (delete)="onDeleteClick($event)"
                (headerClick)="onSwitchToDayView($event)"
                (eventChange)="onEventChange($event)"
                (eventDrop)="onEventDrop($event)"
              />
            }
          }
          @if (calendarViewMode() === CalendarView.Month) {
            @if (calendars$ | async; as calendars) {
              <blaze-calendar-month-view
                [selectedDate]="selectedCalendarDate"
                [calendars]="calendars"
                [firstDayOfWeek]="firstDayOfWeek"
                [hideWeekends]="hideWeekends"
                [timeFormat]="timeFormat"
                [defaultDurationMinutes]="defaultDurationMinutes"
                [isAddEnabled]="isAddEnabled() ?? false"
                [isEditEnabled]="isEditEnabled() ?? false"
                [isDeleteEnabled]="isDeleteEnabled() ?? false"
                [isDetailsViewEnabled]="isDetailsViewEnabled() ?? false"
                [componentStyles]="componentStyles"
                [eventFontSize]="eventFontSize"
                (dateSelected)="onSwitchToDayView($event)"
                (add)="onAddClick($event)"
                (details)="onDetailsClick($event)"
                (edit)="onEditClick($event)"
                (delete)="onDeleteClick($event)"
              />
            }
          }
        </div>
      </div>
    </blaze-scroller>
    @if (isSwipingMode() && calendarViewMode() === CalendarView.Day && allCalendarsLength > 1) {
      <div
        #paginationWrapper
        class="calendar-pagination-wrapper"
        [style.left.px]="timeLineWidthPx"
        [style.width]="'calc(100% - ' + timeLineWidthPx + 'px)'"
      >
        <blaze-mobile-pagination
          [itemsCount]="(calendarsCount$ | async) ?? 0"
          [selectedIndex]="(currentCalendarPageIndex$ | async) ?? 0"
          [color]="secondaryLinesColor"
          [selectedColor]="dateSelectorDefaultText"
        />
      </div>
    }
  </div>
</div>

<ng-template #filtersTpl let-calendars let-filtersVisible="filtersVisible">
  <div
    class="relative flex flex-grow overflow-y-auto"
    [style.height]="getFiltersContainerHeight(calendars.length)"
  >
    <blaze-calendars-filter
      #calendarsFilter
      class="transition-all pt-2 h-auto absolute flex-grow w-full"
      [class.calendars-filter-hidden]="!filtersVisible"
      [calendars]="calendars"
      [viewportMode]="viewportMode"
      [calendarsStyles]="calendarsStyles"
      (calendarsSelectionChange)="calendarsSelectionChange($event)"
    />
  </div>
</ng-template>

<mat-menu #viewToggleMenu="matMenu" class="bd-menu">
  <ng-template matMenuContent let-isMobile="isMobile">
    <button
      mat-menu-item
      [class.item-accent]="calendarViewMode() === 'day'"
      (click)="onSwitchToDayView()"
      ><span>Day</span></button
    >
    <button
      mat-menu-item
      [class.item-accent]="calendarViewMode() === '3day'"
      (click)="onSwitchTo3DayView()"
      ><span>3 Day</span></button
    >
    <button
      mat-menu-item
      [class.item-accent]="calendarViewMode() === 'week'"
      (click)="onSwitchToWeekView()"
      ><span>Week</span></button
    >
    <button
      mat-menu-item
      [class.item-accent]="calendarViewMode() === 'month'"
      (click)="onSwitchToMonthView()"
      ><span>Month</span></button
    >
  </ng-template>
</mat-menu>

<ng-template #headerTitleTpl>
  <blaze-element-header
    [color]="titlesColor"
    [fontFamily]="props?.style?.titleBlock?.fontFamily"
    [fontSize]="props?.style?.titleBlock?.fontSize"
    [fontStyle]="props?.style?.titleBlock?.fontStyle"
    [fontWeight]="props?.style?.titleBlock?.fontWeight"
    [horizontalAlign]="props?.content?.title?.align"
    [icon]="props?.content?.title?.icon"
    [iconColor]="props?.content?.title?.iconColor?.color1"
    [iconPosition]="props?.content?.title?.iconPosition"
    [iconSize]="props?.style?.titleBlock?.iconSize"
    class="grow pl-16"
  >
    {{ calendarTitle.label }}
  </blaze-element-header>
</ng-template>
